// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DeleteIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="DeleteIcon" ref={forwardedRef} {...props}>
      <path d="M7.5 8.002H9v7H7.5z" />
      <path d="M12.5 8.002H11v7h1.5z" />
      <path d="M6 5.004v-1.5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1.5h3.496v1.5H15.5V17a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1V6.504H2.496v-1.5zm1.5 0h5v-1h-5zM6 6.504V16.5h8V6.504z" />
    </SvgIcon>
  );
});

/**
 * Use to permanently delete an item, typically reserved for actions with significant impact
 * @public
 */
export const DeleteIcon = /* @__PURE__ */ Object.assign(DeleteIconComponent, {
  displayName: 'DeleteIcon',
});
